import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import {
  AccountCircle,
  ExitToApp,
  HelpOutline,
  InfoOutlined,
} from '@mui/icons-material';

import { ThemeProvider, createTheme } from '@mui/material/styles';

import { uhuzamlogodark } from '../constants/logos';
import { modernDesignSystem } from '../constants/themes';

import { logout } from './../redux/actions/auth';

import About from './About';

function ResponsiveAppBar() {
  const dispatch = useDispatch();
  const { isLoggedIn } = useSelector((state) => state.auth);

  const [visibleAbout, setVisibleAbout] = useState(false);

  const [anchorElUser, setAnchorElUser] = React.useState(null);

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const modernTheme = createTheme({
    palette: {
      primary: {
        main: modernDesignSystem.colors.primary.main, // Modern yeşil
        dark: modernDesignSystem.colors.primary.dark,
        light: modernDesignSystem.colors.primary.light,
      },
      background: {
        default: modernDesignSystem.colors.primary.main,
        paper: modernDesignSystem.colors.neutral.white,
      },
      text: {
        primary: modernDesignSystem.colors.neutral.white,
        secondary: modernDesignSystem.colors.neutral.gray200,
      }
    },
  });

  if (!isLoggedIn) {
    return <Navigate to="/" />;
  }

  const showAbout = () => {
    setVisibleAbout(true);
    handleCloseUserMenu();
  };

  return (
    <ThemeProvider theme={modernTheme}>
      <AppBar 
        position="static"
        className="main-appbar"
        sx={{
          background: `linear-gradient(135deg, ${modernDesignSystem.colors.primary.main} 0%, ${modernDesignSystem.colors.primary.dark} 100%)`,
          boxShadow: modernDesignSystem.shadows.elevated,
          borderBottom: `2px solid ${modernDesignSystem.colors.primary.surface}`,
        }}
      >
        <Toolbar disableGutters>
          <Box
            component="img"
            sx={{
              mt: 1,
              height: 75,
              width: 220,
            }}
            src={uhuzamlogodark}
          />
          <Typography
            variant="h6"
            noWrap
            sx={{
              ml: 1,
              mt: 3.5,
              display: { xs: 'display', md: 'flex' },
              fontWeight: 700,
              letterSpacing: '.3rem',
              color: modernDesignSystem.colors.neutral.white,
              textDecoration: 'none',
              fontSize: 'h4.fontSize',
              textShadow: '0 2px 4px rgba(0, 0, 0, 0.3)',
              fontFamily: modernDesignSystem.typography.fontFamily.primary,
            }}
          >
            TARSİS
          </Typography>
          <Box
            sx={{
              flexGrow: 1,
              display: { xs: 'block', sm: 'block' },
            }}
          ></Box>
          <Box sx={{ flexGrow: 0, mr: 1 }}>
            <Tooltip title="Kullanıcı Menüsü" arrow>
              <IconButton 
                onClick={handleOpenUserMenu} 
                sx={{ 
                  color: modernDesignSystem.colors.neutral.white,
                  '&:hover': {
                    backgroundColor: modernDesignSystem.colors.primary.light + '20',
                    transform: 'scale(1.05)',
                  },
                  transition: 'all 0.2s ease',
                }}
              >
                <AccountCircle sx={{ 
                  fontSize: '40px',
                  filter: 'drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3))'
                }} />
              </IconButton>
            </Tooltip>
            <Menu
              sx={{ 
                mt: '45px',
                '& .MuiPaper-root': {
                  borderRadius: modernDesignSystem.borders.radius.medium,
                  boxShadow: modernDesignSystem.shadows.elevated,
                  border: `1px solid ${modernDesignSystem.colors.neutral.gray200}`,
                  minWidth: '200px',
                }
              }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              <MenuItem 
                onClick={() => showAbout()}
                sx={{
                  '&:hover': {
                    backgroundColor: modernDesignSystem.colors.primary.surface,
                  },
                  borderRadius: '8px',
                  margin: '4px 8px',
                }}
              >
                <ListItemIcon>
                  <InfoOutlined sx={{ color: modernDesignSystem.colors.primary.main }} />
                </ListItemIcon>
                <ListItemText 
                  primary="Hakkında" 
                  sx={{
                    '& .MuiListItemText-primary': {
                      color: modernDesignSystem.colors.neutral.gray800,
                      fontWeight: 500,
                    }
                  }}
                />
              </MenuItem>
              <MenuItem 
                onClick={() => dispatch(logout())}
                sx={{
                  '&:hover': {
                    backgroundColor: modernDesignSystem.colors.semantic.error + '10',
                  },
                  borderRadius: '8px',
                  margin: '4px 8px',
                }}
              >
                <ListItemIcon>
                  <ExitToApp sx={{ color: modernDesignSystem.colors.semantic.error }} />
                </ListItemIcon>
                <ListItemText 
                  primary="Oturumu Kapat" 
                  sx={{
                    '& .MuiListItemText-primary': {
                      color: modernDesignSystem.colors.neutral.gray800,
                      fontWeight: 500,
                    }
                  }}
                />
              </MenuItem>
            </Menu>
            <About visible={visibleAbout} visibleFunc={setVisibleAbout} />
          </Box>
        </Toolbar>
      </AppBar>
    </ThemeProvider>
  );
}
export default ResponsiveAppBar;
